import type { IWordGameReportItem } from '@/types/Data'
import type { IGetWordGameReport } from '@/types/Request'
import BaseService from '../BaseService'

export default class WordGameReportServices extends BaseService {
  GetWordGameReport(payload: IGetWordGameReport) {
    return this.POST<IWordGameReportItem[]>(this.PATHS.GET_WORD_GAME_REPORT, payload)
  }

  GetWordGameReportExcel(payload: IGetWordGameReport) {
    return this.EXCEL(this.PATHS.GET_WORD_GAME_REPORT_EXCEL, true, payload)
  }
}
